import { render, staticRenderFns } from "./EmployerSalaryReport.vue?vue&type=template&id=353c6d7a&scoped=true&"
import script from "./EmployerSalaryReport.vue?vue&type=script&lang=js&"
export * from "./EmployerSalaryReport.vue?vue&type=script&lang=js&"
import style0 from "./EmployerSalaryReport.vue?vue&type=style&index=0&id=353c6d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353c6d7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/projects/accurate/acc-dashboard/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VDataTable,VDatePicker,VFlex,VLayout})
